import React, { FunctionComponent } from 'react';
import { Grid } from '@rbx/ui';
import OpenCloudAPIEndpoint from '../../../utils/interfaces/OpenCloudAPIEndpoint';
import EndpointContainer from './EndpointContainer';
import EndpointsCategoryContainer from './EndpointsCategoryContainer';

export interface OpenCloudEndpointsContainerProps {
  endpoints: OpenCloudAPIEndpoint[];
  serverUrl?: string;
}

const OpenCloudEndpointsContainer: FunctionComponent<
  React.PropsWithChildren<OpenCloudEndpointsContainerProps>
> = ({ endpoints, serverUrl }) => {
  return (
    <Grid container direction='column' wrap='nowrap'>
      {endpoints.map((endpointGroup) => {
        return (
          <Grid key={endpointGroup.category} container direction='column' wrap='nowrap'>
            <EndpointsCategoryContainer endpoint={endpointGroup} serverUrl={serverUrl} />
            {endpointGroup.paths.map((path) =>
              path.operations.map((operation) => (
                <EndpointContainer key={operation.name} operation={operation} path={path.path} />
              )),
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default OpenCloudEndpointsContainer;
